import styles from './CoreImage.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import Link from 'next/link';
import { Image } from '@/components';

let cx = className.bind(styles);

export default function CoreImage(props) {
	const { attributes, mediaDetails } = props;
	const className = attributes.className?.split(' ') || [];

	let height, width;
	if ((attributes.height && attributes.height !== 'auto') || (attributes.width && attributes.width !== 'auto')) {
		const aspectRatio = mediaDetails.height / mediaDetails.width;
		if (!attributes.height || attributes.height === 'auto') {
			width = attributes.width.match(/^\d+/)[0];
			height = width * aspectRatio;
		} else if (!attributes.width || attributes.width === 'auto') {
			height = attributes.height.match(/^\d+/)[0];
			width = height / aspectRatio;
		} else {
			height = attributes.height.match(/^\d+/)[0];
			width = attributes.width.match(/^\d+/)[0];
		}
	} else {
		height = mediaDetails?.height;
		width = mediaDetails?.width;
	}
  
	function RenderImage() {
		return attributes.src && width && height ? <Image id={attributes.anchor} className={cx(['core-image', ...className, attributes.align && `align-${attributes.align}`, width > height ? 'horz-image' : 'vert-image'])} height={height} width={width} alt={attributes.alt} src={attributes.src} loading={attributes.imageLoading} /> : null;
	}
	return attributes.href ? (
		<Link href={attributes.href} target={attributes.linkTarget} rel={attributes.rel} className={attributes.linkClass}>
			<RenderImage />
		</Link>
	) : (
		<RenderImage />
	);
}

CoreImage.fragments = {
	key: `CoreImageFragment`,
	entry: gql`
		fragment CoreImageFragment on CoreImage {
			mediaDetails {
				height
				width
			}
			attributes {
				align
				href
				height
				width
				alt
				className
				linkClass
				linkTarget
				rel
				src
				anchor
			}
		}
	`,
};

CoreImage.config = {
	name: 'CoreImage',
};
CoreImage.displayName = 'CoreImage';
